import { defineQuery } from 'next-sanity'
import { inlineCtaFields } from '../atoms'

export const careersRolesBlockFields = `
  _id,
  _type,
  roles[]{
    roleTitle,
    roleDescription,
    roleButtonLink {
      ${inlineCtaFields}
    },
    supplementaryColumns[]{
      heading,
      mainText,
      videoEmbed
    }
  }
`

export const CAREERS_ROLES_BLOCK_QUERY = defineQuery(/* groq */ `
  *[_type == "careers-roles-block"][0]{
    ${careersRolesBlockFields}
  }
`)
